import MasteriesSlider from './parts/masteries-slider';
import SlideOver from './parts/slide-over';
import Plyr from './parts/plyr';

// Init Masteries Slider
document.addEventListener('DOMContentLoaded', () => {
	// Masteries slide over
	const masteriesSlideOver = document.querySelector('#masteries-slide-over');
	new SlideOver(masteriesSlideOver).render('hidden');

	// Masteries Slider
	const sliders = Array.from(document.querySelectorAll('#masteries-slider'));
	sliders.map(slider => new MasteriesSlider(slider).init());
});
